<template>
  <el-form
    ref="editform"
    :model="editForm"
    :rules="rules"
  >
    <el-form-item>
      <p class="self-label">{{$t('withgold.accountNumber')}}</p>
      <el-input
        disabled
        :value="login"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="nickName"
    >
      <nickname-tips></nickname-tips>
      <el-input
        :disabled="nickNameDisabled"
        :placeholder="phFileter($t('please_enter'),this)"
        v-model="editForm.nickName"></el-input>
    </el-form-item>
    <el-form-item>
      <account-role-tips></account-role-tips>
      <el-select
        style="width: 100%"
        :disabled="accountTypeDisabled"
        v-model="editForm.accountType"
      >
        <el-option
          v-for="(item,index) in accountTypeOptions"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <mam-master-setting
      v-if="mamMasterSettingFlag"
      @send-form="mamMasterSendFormHandle"
      ref="mammastersetting"
    ></mam-master-setting>
  </el-form>
</template>

<script>
import accountRoleTips from '@/components/public/accountRoleTips'
import nicknameTips from '@/components/public/nicknameTips'
import { phFileter } from '@/utils/common';
import { updateLoginConfig, queryLoginConfig } from '@/api/config'
import mamMasterSetting from '@/components/common/mamMasterSetting'
export default {
  name: "accountTypeSetForm",
  components:{
    mamMasterSetting,
    accountRoleTips,
    nicknameTips,
  },
  props: {
    accountMtId: {},
    accountMt: {},
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let _this = this;
    return {
      editForm: {
        nickName: '',
        accountType: '',
      },
      rules:{
        nickName:[
          { required: true, message: _this.$t('Please_enter_a_nickname'), trigger: 'blur' }
        ]
      },
      accountTypeOptions:[
        {
          label: _this.$t('Ordinary_account'),
          value: 0,
        },
        {
          label: _this.$t('Wallet_account'),
          value: 3,
        },
        /*{
          label: _this.$t('Social_master_account'),
          value: 4,
        },
        {
          label: _this.$t('Social_Investment_Account'),
          value: 5,
        },*/
        {
          label: _this.$t('MAM_master_account'),
          value: 6
        },
      ],
      accountTypeDisabled: false,
      nickNameDisabled: false,
      login: '',
      businessType: '',
      tier: '',
    };
  },
  watch:{
    accountMtId(newValue){
      if(newValue){
        if(this.accountMt.businessType !=5 && this.accountMt.businessType !=6){
            this.querInfo();
        }
      }
    },
    dialogShow(newValue){
      if(newValue && this.accountMtId){
        if(this.accountMt.businessType !=5 && this.accountMt.businessType !=6){
            this.querInfo();
        }
      }
    },
  },
  computed: {
    mamMasterSettingFlag(){
      return this.editForm.accountType == 6;
    },
  },
  methods: {
    phFileter,
    querInfo(){
      queryLoginConfig({
        mtId: +this.accountMtId,
      }).then((res) => {
        this.editForm.nickName = res.data.alias;
        this.cacheAlias = res.data.alias;
        if(res.data.alias){
          this.nickNameDisabled = true;
        }
        this.login = res.data.login;

        this.businessType = res.data.businessType;
        this.tier = res.data.tier;
        this.editForm.accountType = this.turnType();
        if(res.data.businessType == 3){
          this.accountTypeDisabled = true;
        }else {
          this.accountTypeDisabled = false;
        }
      })
    },
    turnType(){
      if(this.businessType == 0 || this.businessType == 1){
        return 0;
      }else if(this.businessType == 2){
        return 6;
      }else if(this.businessType == 3){
        return 3
      }
    },
    saveHandle(){
      this.$refs.editform.validate((valid) => {
        if(valid){
          //
          switch (this.editForm.accountType) {
            case 6:
              this.$refs.mammastersetting.validate();
              break;
            case 3:
              if(this.editForm.nickName !== this.cacheAlias){
                updateLoginConfig({
                  mtId: this.accountMtId,
                  alias: this.editForm.nickName,
                  businessType: 3,
                  tier: 0,
                }).then((res) => {
                  this.$message({
                    type: 'success',
                    message: this.$t('Saved_successfully'),
                  });
                  this.$emit('success-set');
                })
              }else {
                this.$confirm(this.$t('Wallet_account_edit_tips'), this.$t('Confirm_save'), {
                  confirmButtonText: this.$t('root.confirm'),
                  cancelButtonText: this.$t('root.cancle'),
                  type: 'warning',
                  customClass: 'self-messagebox-wrapper'
                }).then(() => {
                  // 修改之后不能再修改
                  this.accountTypeDisabled = true;
                  updateLoginConfig({
                    mtId: this.accountMtId,
                    businessType: 3,
                    tier: 0,
                  }).then((res) => {
                    this.$message({
                      type: 'success',
                      message: this.$t('Saved_successfully'),
                    });
                    this.$emit('success-set');
                  })
                }).catch(() => {
                  //几点取消的提示
                });
              }
              break;
            case 0:
              updateLoginConfig({
                mtId: +this.accountMtId,
                businessType: 0,
                tier: 0,
                alias: this.editForm.nickName,
              }).then((res) => {
                this.$message({
                  type: 'success',
                  message: this.$t('Saved_successfully'),
                });
                this.$emit('success-set');
              })
              break;
          }

        }else {
          console.log('error');
        }
      })
    },
    mamMasterSendFormHandle(editForm){
      this.$confirm(this.$t('idChangeTips'), this.$t('Confirm_save'), {
        confirmButtonText: this.$t('root.confirm'),
        cancelButtonText: this.$t('root.cancle'),
        type: 'warning',
        customClass: 'self-messagebox-wrapper'
      }).then(() => {
        this.accountTypeDisabled = true;
        let params = {
          mtId: this.accountMtId,
          alias: this.editForm.nickName,
          isOpen: editForm.isOpen ? 1: 0,
          isFree: editForm.isCharge ? 0: 1,
          businessType:2,
          tier: 1
        };
        if(editForm.isOpen){
          if(editForm.strategy){
            params.tradeStrategy = editForm.strategy;
          }
          if(editForm.limit){
            params.subAmount = editForm.limit;
          }
          if(editForm.copyPassword){
            params.subPassword = editForm.copyPassword;
          }
        }
        if(editForm.isCharge){
          if(editForm.managementFee){
            params.price = editForm.managementFee
          }
          params.sharePrice = editForm.sharePrice;
        }
        updateLoginConfig(params).then((res) => {
          this.$message({
            type: 'success',
            message: this.$t('Saved_successfully'),
          });
          this.$emit('success-set');
        })
      }).catch(() => {
      });
    },
    clear(){
      this.$refs.editform.resetFields();
      this.$refs.editform.clearValidate();
    }
  }
}
</script>


